<template>
  <div class="sidebar-separator">
    <hr class="border-none bg-50" style="height: 1px" />
  </div>
</template>

<script>
export default {
  props: ['item'],
}
</script>
